import PropTypes from 'prop-types'

/**
 * UI feature limits entry type definition.
 *
 * @typedef {Object} UiFeatureLimit
 * @property {boolean} [disabled]
 * @property {number} [volume]
 */
export const uiFeatureLimitPropType = PropTypes.shape({
    disabled: PropTypes.bool,
    volume: PropTypes.number
})
